const newDialog = {
  state: {
    newdialog: false
  },

  mutations: {
    SET_DIALOG_SHOW(state, val) {
      state.newDialog = val
    }
  }
}

export default newDialog
